import { render, staticRenderFns } from "./__HistoryProductInfo.vue?vue&type=template&id=8498a072&"
import script from "./__HistoryProductInfo.vue?vue&type=script&lang=js&"
export * from "./__HistoryProductInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports